var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 25,
    viewBox: "0 0 140 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4043 23.1676V2.46596C1.4043 2.08871 1.90322 1.94944 2.10102 2.27147L11.7269 17.9437C13.1921 20.3292 16.6788 20.3292 18.144 17.9437L27.7699 2.27147C27.9677 1.94943 28.4666 2.08871 28.4666 2.46596V23.1676M34.1046 1.13712L46.884 13.8327M46.884 13.8327L59.6634 1.13712M46.884 13.8327V23.541M64.1738 23.0283V2.17338C64.1738 0.788402 65.9068 0.149282 66.8165 1.19877L84.8347 21.9858C85.7444 23.0353 87.4774 22.3962 87.4774 21.0112V0.15625M92.7396 0.390321V14.5795C92.7396 19.5288 96.7783 23.541 101.76 23.541H104.016C108.998 23.541 113.036 19.5288 113.036 14.5795V0.390321M118.298 0.390321V14.5795C118.298 19.5288 122.337 23.541 127.319 23.541H129.574C134.556 23.541 138.595 19.5288 138.595 14.5795V0.390321",
    stroke: "url(#paint0_linear_1195_7114)",
    strokeWidth: 1.03932
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1195_7114",
    x1: 157.388,
    y1: -3.34367,
    x2: 158.872,
    y2: 43.7052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4f407d6049ce1e585defdb8b47c41514.svg";
export { ForwardRef as ReactComponent };